import { gql } from '@apollo/client';
import {
  ILibraryCategoryShop,
  LibraryCategoryShopFragment,
} from './libraryCategoryShop';
import {
  ILibrarySocialMediaLinks,
  LibrarySocialMediaLinksFragment,
} from './librarySocialMediaLinks';
import { IMeetingPlaceSeoDescription } from '@/interfaces/meetingPlaceSeoDescription';

export interface ILibraryBrandShop {
  id: string;
  name: string;
  slug: string;
  description: any;
  logo: any;
  coverImage: any;
  primaryCategory: ILibraryCategoryShop;
  secondaryCategories: ILibraryCategoryShop[];
  socialMediaLinks: ILibrarySocialMediaLinks;
  seoDescription: IMeetingPlaceSeoDescription;
}

export const LibraryBrandShopMinifiedFragment = gql`
  ${LibraryCategoryShopFragment}
  fragment LibraryBrandShopMinified on LibraryBrandShop {
    sys {
      id
      locale
    }
    name
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryShop
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryShop
      }
    }
  }
`;

export const LibraryBrandShopFragment = gql`
  ${LibraryCategoryShopFragment}
  ${LibrarySocialMediaLinksFragment}
  fragment LibraryBrandShop on LibraryBrandShop {
    sys {
      id
    }
    name
    brandId
    slug
    description {
      json
    }
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryShop
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryShop
      }
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
    seoDescription
  }
`;
